module.exports = __webpack_public_path__ + "static/furniture-tree-a9ab6b69bf622d809322013602b4f871.png";